export const defaultErrorMessage = "Ocorreu um erro ao tentar realizar a ação:\n"
export const tryAgainMessage = "\nTente novamente, se o erro persistir, entre em contato com o suporte.";